import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// eslint-disable-next-line max-len
import { UniversalProductsCategory } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsTreeResponse';
import { ExternalLinkIcon } from 'assets/icons';
import { getUserContext } from 'domains/user';
import { MenuItem } from 'pages/UniversalProductsPage/Menu/Menu.styled';
import { Box, Flex, Icon, Link, Text } from 'UI';
import { Country } from 'utils/i18n/Country';

interface MainCategoriesProps {
  openCategoryId: string;
  setOpenCategoryId: (id: string) => void;
  universalProductsTree: UniversalProductsCategory[];
}

const MainCategories = ({ universalProductsTree, openCategoryId, setOpenCategoryId }: MainCategoriesProps) => {
  const { t } = useTranslation();
  const userCountry = useSelector(getUserContext).userCountry;
  const isSpanishUser = userCountry === Country.ES.key;
  const ROUTER_EXTERNAL_WORKSHOP_EQUIPMENT = 'https://sodicam.es';

  return (
    <Box>
      <Flex direction={'column'} gap={8}>
        <Text type="heading3" disableGutter noWrap>
          {t('common.all_categories', 'All categories')}
        </Text>
        {universalProductsTree.map((category) => {
          return (
            <MenuItem
              key={category.nodeId}
              active={openCategoryId === category.nodeId}
              onClick={() => {
                setOpenCategoryId(category.nodeId);
              }}
            >
              <Text type="lg" bold disableGutter noWrap>
                {category.name}
              </Text>
            </MenuItem>
          );
        })}
        {isSpanishUser && (
          <MenuItem>
            <Link to={ROUTER_EXTERNAL_WORKSHOP_EQUIPMENT} external newTab>
              <Flex gap={10} align={'center'}>
                <Text type="lg" bold disableGutter noWrap>
                  {t('catalog.universal_products.workshop_equipment', 'Workshop Equipment')}
                </Text>
                <Icon IconComponent={ExternalLinkIcon} size={20} />
              </Flex>
            </Link>
          </MenuItem>
        )}
      </Flex>
    </Box>
  );
};

export default MainCategories;
